import { Center, Heading, Text, VStack } from '@chakra-ui/react';
import { Users } from 'lucide-react';
import { useT } from '../../i18n';

// Shown by family-scoped app pages when no family is selected yet.
export function NoFamilySelected() {
  const t = useT();
  return (
    <Center h="full" px={6}>
      <VStack spacing={3} textAlign="center">
        <Users size={32} />
        <Heading size="sm">{t('account.noFamily.title')}</Heading>
        <Text color="gray.500" fontSize="sm">
          {t('account.noFamily.body')}
        </Text>
      </VStack>
    </Center>
  );
}
